import { createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-px-4 tw-pt-4 tw-pb-3 sm:tw-px-5" }
const _hoisted_2 = { class: "tw-flex tw-flex-wrap tw-gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "tw-mt-4 tw-rounded-2xl tw-border tw-border-emerald-200/70 tw-bg-emerald-50/60 tw-p-4"
}
const _hoisted_4 = {
  key: 0,
  class: "tw-text-sm sm:tw-text-base tw-font-semibold tw-text-emerald-900"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-text-sm sm:tw-text-base tw-font-semibold tw-text-emerald-900"
}
const _hoisted_6 = { class: "tw-mt-3 tw-overflow-x-auto" }
const _hoisted_7 = { class: "tw-w-full tw-text-left tw-text-sm" }
const _hoisted_8 = { class: "tw-divide-y tw-divide-emerald-200/60" }
const _hoisted_9 = { class: "tw-px-3 tw-py-2 tw-font-medium" }
const _hoisted_10 = { class: "tw-px-3 tw-py-2" }
const _hoisted_11 = { class: "tw-px-3 tw-py-2" }
const _hoisted_12 = { class: "tw-px-3 tw-py-2" }
const _hoisted_13 = { class: "tw-mt-4 tw-flex tw-justify-end" }
const _hoisted_14 = { class: "tw-mt-4" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4" }
const _hoisted_18 = {
  key: 0,
  class: "tw-mt-2 tw-text-sm tw-text-rose-600"
}
const _hoisted_19 = { class: "tw-mt-3 tw-grid tw-grid-cols-1 tw-gap-2" }
const _hoisted_20 = { class: "tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-px-3 tw-py-2" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "tw-text-sm tw-font-medium tw-text-slate-800" }
const _hoisted_23 = { class: "tw-mt-4" }
const _hoisted_24 = {
  key: 0,
  class: "tw-text-sm tw-text-rose-600"
}
const _hoisted_25 = { class: "tw-mt-2 tw-flex" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4" }
const _hoisted_30 = { class: "tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-xl tw-bg-white/50 tw-px-3 tw-py-2" }
const _hoisted_31 = { class: "tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-xl tw-px-3 tw-py-2" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "tw-mt-2 tw-grid tw-grid-cols-1 tw-gap-2" }
const _hoisted_34 = { class: "tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-px-3 tw-py-2" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "tw-text-sm tw-font-medium tw-text-slate-800" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "tw-mt-3 tw-text-sm tw-text-rose-600" }
const _hoisted_39 = {
  key: 1,
  class: "tw-mt-4 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4"
}
const _hoisted_40 = { class: "tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_41 = { class: "tw-mt-2 tw-grid tw-grid-cols-1 tw-gap-2" }
const _hoisted_42 = { class: "tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-px-3 tw-py-2" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "tw-text-sm tw-font-medium tw-text-slate-800" }
const _hoisted_45 = {
  key: 0,
  class: "tw-mt-3 tw-text-sm tw-text-rose-600"
}
const _hoisted_46 = { class: "tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-2" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 1,
  class: "tw-mt-4"
}
const _hoisted_49 = { class: "tw-rounded-2xl tw-border tw-border-indigo-200/70 tw-bg-indigo-50/60 tw-p-4" }
const _hoisted_50 = { class: "tw-text-sm tw-font-medium tw-text-indigo-900" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 1,
  class: "tw-mt-4"
}
const _hoisted_53 = { class: "tw-rounded-2xl tw-border tw-border-indigo-200/70 tw-bg-indigo-50/60 tw-p-4" }
const _hoisted_54 = { class: "tw-text-sm tw-font-medium tw-text-indigo-900" }
const _hoisted_55 = {
  key: 2,
  class: "tw-mt-4"
}
const _hoisted_56 = { class: "tw-rounded-2xl tw-border tw-border-indigo-200/70 tw-bg-indigo-50/60 tw-p-4" }
const _hoisted_57 = { class: "tw-text-sm tw-font-medium tw-text-indigo-900" }
const _hoisted_58 = {
  key: 0,
  class: "tw-h-2"
}
const _hoisted_59 = {
  key: 1,
  class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2"
}
const _hoisted_60 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SearchInput = _resolveComponent("SearchInput")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Modal, {
      isOpen: _ctx.isAddContainerModalOpen,
      "onUpdate:isOpen": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isAddContainerModalOpen) = $event)),
      modalId: "tracking-add-container-modal",
      maxWidth: "6xl",
      ariaLabel: "Add containers"
    }, {
      title: _withCtx(() => [...(_cache[18] || (_cache[18] = [
        _createTextVNode(" Scrape & Add New Container(s) ", -1)
      ]))]),
      subtitle: _withCtx(() => [...(_cache[19] || (_cache[19] = [
        _createTextVNode(" Scrape containers by container number (from Terminal website) or by Bill of Lading number (from Steamship or Terminal website). ", -1)
      ]))]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium", _ctx.activeTab === 'container' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200/70 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'container'))
            }, " by Container Number ", 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium", _ctx.activeTab === 'bl' ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200/70 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'bl'))
            }, " by Bill Of Lading Number ", 2)
          ]),
          (_ctx.fetchedContainers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.fetchedBL)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_4, "Found " + _toDisplayString(_ctx.fetchedContainers.length) + " containers for BL " + _toDisplayString(_ctx.fetchedBL.billOfLadingNumber), 1))
                  : (_openBlock(), _createElementBlock("h2", _hoisted_5, "Found " + _toDisplayString(_ctx.fetchedContainers.length) + " containers!", 1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _cache[20] || (_cache[20] = _createElementVNode("thead", { class: "tw-text-xs tw-uppercase tw-tracking-wide tw-text-emerald-900/70" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Container Number"),
                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Size/Type"),
                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Yard Status"),
                        _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Terminal")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fetchedContainers, (container, containerIdx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `fetched-container-${containerIdx}`,
                          class: "tw-text-emerald-950"
                        }, [
                          _createElementVNode("td", _hoisted_9, _toDisplayString(container.containerId), 1),
                          _createElementVNode("td", _hoisted_10, _toDisplayString(container.sizeType), 1),
                          _createElementVNode("td", _hoisted_11, _toDisplayString(container.yardStatusDescription), 1),
                          _createElementVNode("td", _hoisted_12, _toDisplayString(container.terminal), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-shadow-slate-900/10 hover:tw-bg-slate-800",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetContainers && _ctx.resetContainers(...args)))
                  }, "OK")
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.activeTab === 'container')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (!_ctx.fetchedContainers)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", null, [
                            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "tw-text-sm tw-font-medium tw-text-slate-700" }, "Container numbers", -1)),
                            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "tw-mt-1 tw-text-xs tw-text-slate-500" }, "Enter one container per line.", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.containerNumbers) = $event)),
                              cols: "30",
                              rows: "10",
                              class: _normalizeClass(["tw-mt-3 tw-w-full tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2.5 tw-text-sm tw-leading-6 tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/20", _ctx.containerFormError ? 'tw-border-rose-300 focus:tw-ring-rose-500/20' : '']),
                              placeholder: 'MSCU1234567\nTGHU7654321'
                            }, null, 2), [
                              [_vModelText, _ctx.containerNumbers]
                            ]),
                            (_ctx.containerFormError && _ctx.hasAttemptedContainerSubmit)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.containerFormError), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "tw-text-sm tw-font-medium tw-text-slate-700" }, "Terminal", -1)),
                            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "tw-mt-1 tw-text-xs tw-text-slate-500" }, " ", -1)),
                            _createElementVNode("div", _hoisted_19, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['TRAPAC', 'OICT', 'ETS'], (terminalId) => {
                                return _createElementVNode("label", _hoisted_20, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "tw-cursor-pointer",
                                    type: "radio",
                                    name: "terminalForContainerScraping",
                                    value: terminalId,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.terminal) = $event))
                                  }, null, 8, _hoisted_21), [
                                    [_vModelRadio, _ctx.terminal]
                                  ]),
                                  _createElementVNode("span", _hoisted_22, _toDisplayString(terminalId), 1)
                                ])
                              }), 64))
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_23, [
                    (_ctx.hasAttemptedContainerSubmit && !_ctx.isContainerListValid)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Your container Numbers are not valid. Please verify."))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-shadow-slate-900/10 hover:tw-bg-slate-800", !_ctx.canSubmitContainers ? 'tw-opacity-60' : '']),
                        disabled: _ctx.loadingContainer || !_ctx.canSubmitContainers,
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.trackContainer && _ctx.trackContainer(...args)))
                      }, "Scrape & Add Container(s)", 10, _hoisted_26)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (!_ctx.fetchedBL)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", null, [
                            _cache[27] || (_cache[27] = _createElementVNode("label", {
                              for: "blNumber",
                              class: "tw-text-sm tw-font-medium tw-text-slate-700"
                            }, "Bill Of Lading Number", -1)),
                            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "tw-mt-1 tw-text-xs tw-text-slate-500" }, "Enter BL number to scrape containers for (only ONE BL number allowed at a time)", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.billOfLadingNumber) = $event)),
                              type: "text",
                              id: "blNumber",
                              class: _normalizeClass(["tw-mt-2 tw-w-full tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/20", _ctx.textDanger ? 'tw-border-rose-300 focus:tw-ring-rose-500/20' : '']),
                              placeholder: "e.g. ONEY123456789"
                            }, null, 2), [
                              [_vModelText, _ctx.billOfLadingNumber]
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_30, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "tw-cursor-pointer",
                                  type: "radio",
                                  name: "typeOfBlScraping",
                                  value: "shiplineWebsite",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.billOfLadingNumberScrapeSource) = $event))
                                }, null, 512), [
                                  [_vModelRadio, _ctx.billOfLadingNumberScrapeSource]
                                ]),
                                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "tw-text-sm tw-font-medium tw-text-slate-800" }, "from Steamshipline Website ", -1))
                              ]),
                              _createElementVNode("label", _hoisted_31, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "tw-cursor-pointer",
                                  type: "radio",
                                  name: "typeOfBlScraping",
                                  value: "terminalWebsite",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.billOfLadingNumberScrapeSource) = $event))
                                }, null, 512), [
                                  [_vModelRadio, _ctx.billOfLadingNumberScrapeSource]
                                ]),
                                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "tw-text-sm tw-font-medium tw-text-slate-800" }, "from Terminal Website ", -1))
                              ])
                            ])
                          ]),
                          (_ctx.billOfLadingNumberScrapeSource === 'terminalWebsite')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "tw-text-sm tw-font-medium tw-text-slate-700" }, "Terminal", -1)),
                                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "tw-mt-1 tw-text-xs tw-text-slate-500" }, " ", -1)),
                                _createElementVNode("div", _hoisted_33, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['OICT', 'ETS', 'TRAPAC'], (terminalId) => {
                                    return _createElementVNode("label", _hoisted_34, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "tw-cursor-pointer",
                                        type: "radio",
                                        name: "terminalForBlScraping",
                                        value: terminalId,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.blScrapeTerminal) = $event))
                                      }, null, 8, _hoisted_35), [
                                        [_vModelRadio, _ctx.blScrapeTerminal]
                                      ]),
                                      _createElementVNode("span", _hoisted_36, _toDisplayString(terminalId), 1)
                                    ])
                                  }), 64))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.blFormError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.blFormError), 1),
                              (_ctx.billOfLadingNumber && !_ctx.blManualOverride && (_ctx.askManualOverride))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "tw-mt-2 tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-shadow-slate-900/10 hover:tw-bg-slate-800",
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.triggerManualBLEntry && _ctx.triggerManualBLEntry(...args)))
                                  }, "Manually Add Bill of Lading"))
                                : (_ctx.billOfLadingNumber && _ctx.blManualOverride)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _createElementVNode("p", _hoisted_40, "Enter all the containers for " + _toDisplayString(_ctx.billOfLadingNumber), 1),
                                      _cache[32] || (_cache[32] = _createElementVNode("p", { class: "tw-mt-1 tw-text-xs tw-text-slate-500" }, "Enter one container per line.", -1)),
                                      _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.manualContainers) = $event)),
                                        cols: "30",
                                        rows: "10",
                                        class: "tw-mt-3 tw-w-full tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-px-3 tw-py-2.5 tw-text-sm tw-leading-6 tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/20",
                                        placeholder: 'MSCU1234567\nTGHU7654321'
                                      }, null, 512), [
                                        [_vModelText, _ctx.manualContainers]
                                      ]),
                                      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "tw-mt-3 tw-text-sm tw-font-medium tw-text-slate-700" }, "Terminal", -1)),
                                      _createElementVNode("div", _hoisted_41, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['TRAPAC', 'ETS', 'OICT'], (terminalId) => {
                                          return _createElementVNode("label", _hoisted_42, [
                                            _withDirectives(_createElementVNode("input", {
                                              class: "tw-cursor-pointer",
                                              type: "radio",
                                              name: "terminalForManualContainerEntry",
                                              value: terminalId,
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.manualContainersTerminal) = $event))
                                            }, null, 8, _hoisted_43), [
                                              [_vModelRadio, _ctx.manualContainersTerminal]
                                            ]),
                                            _createElementVNode("span", _hoisted_44, _toDisplayString(terminalId), 1)
                                          ])
                                        }), 64))
                                      ]),
                                      (_ctx.hasAttemptedManualSubmit && !_ctx.isManualContainerListValid)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_45, "Your container Numbers are not valid. Please verify."))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("button", {
                                          class: _normalizeClass(["tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-shadow-slate-900/10 hover:tw-bg-slate-800", !_ctx.canSubmitManualContainers ? 'tw-opacity-60' : '']),
                                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addBLWithContainersManually && _ctx.addBLWithContainersManually(...args))),
                                          disabled: _ctx.loadingManualBL || !_ctx.canSubmitManualContainers
                                        }, "Confirm BL is correct", 10, _hoisted_47),
                                        _createElementVNode("button", {
                                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.cancelManualBLEntry && _ctx.cancelManualBLEntry(...args))),
                                          class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50"
                                        }, "Cancel")
                                      ]),
                                      (_ctx.loadingManualBL)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                            _createElementVNode("div", _hoisted_49, [
                                              _createElementVNode("p", _hoisted_50, "Fetching Container details for BL " + _toDisplayString(_ctx.billOfLadingNumber), 1),
                                              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "tw-mt-2 tw-text-sm tw-text-indigo-800" }, "Loading...", -1))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.blManualOverride && _ctx.showBlScrapeButton)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "tw-mt-4 tw-inline-flex tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-shadow-slate-900/10 hover:tw-bg-slate-800",
                        disabled: _ctx.loadingBL || !_ctx.billOfLadingNumber,
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.trackBillOfLading && _ctx.trackBillOfLading(...args)))
                      }, "Scrape & Add Container(s) for Bill of Lading", 8, _hoisted_51))
                    : _createCommentVNode("", true)
                ]))
          ]),
          (_ctx.loadingBL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("p", _hoisted_54, [
                    (_ctx.billOfLadingNumberScrapeSource === 'terminalWebsite')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" Fetching containers for BL " + _toDisplayString(_ctx.billOfLadingNumber) + " at " + _toDisplayString(_ctx.blScrapeTerminal), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Fetching container details for BL " + _toDisplayString(_ctx.billOfLadingNumber), 1)
                        ], 64))
                  ]),
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "tw-mt-2 tw-text-sm tw-text-indigo-800" }, "Loading...", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.loadingContainer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("p", _hoisted_57, "Fetching Container details for container " + _toDisplayString(_ctx.containerNumbers) + " at Terminal " + _toDisplayString(_ctx.terminal), 1),
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "tw-mt-2 tw-text-sm tw-text-indigo-800" }, "Loading...", -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    (!_ctx.hideSearch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_58))
      : _createCommentVNode("", true),
    (!_ctx.isSearching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
          _createVNode(_component_Button, {
            onClick: _ctx.addNewContainerModal,
            variant: "secondary"
          }, {
            default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
              _createTextVNode(" Scrape & Add New Container(s) ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            isDefault: true,
            enableLoading: _ctx.yardStatusLoading,
            onClick: _ctx.updateYardStatus,
            title: "Update the status of all containers at the terminals"
          }, {
            default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
              _createTextVNode(" Re-scrape All Containers ", -1)
            ]))]),
            _: 1
          }, 8, ["enableLoading", "onClick"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hideSearch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createVNode(_component_SearchInput, {
            modelValue: _ctx.searchTerm,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.searchTerm) = $event)),
            placeholder: "Container Number, B/L Number, or Customer Name",
            class: "tw-w-full sm:tw-max-w-lg"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}